import { createLazyComponent, LazyModule, type LazyComponent } from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AccessibilityLoopTeachingBubble" */ './lazyIndex'),
    { name: 'AccessibilityLoopTeachingBubble' }
);

export const LazyF6TeachingBubble: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.F6TeachingBubble
);
